"use strict";

exports.__esModule = true;
var _UsersSelector = require("./UsersSelector");
Object.keys(_UsersSelector).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _UsersSelector[key]) return;
  exports[key] = _UsersSelector[key];
});